import React from 'react';
import {
  AreaChart, Area, BarChart, Bar, LineChart, Line, ComposedChart,
  XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer,
  Cell, ReferenceLine, ReferenceArea, Legend
} from "recharts";
import {
  RouteIcon, TrendingUp, Users, Activity, Crosshair, Sparkles,
  Trophy, ClipboardList, NotebookPen, Plus, Pencil, Trash2,
  ChevronDown, ChevronUp, Search, ArrowUpRight, ArrowDownRight,
  Download, Calendar, Clock, CheckCircle2, XCircle, AlertTriangle,
  Info, Zap, Brain, BarChart3, X, UserCheck, Building2,
  HeartHandshake, CalendarDays, CalendarCheck, Stethoscope,
  FlaskConical, Headphones, Receipt, Smartphone, Globe,
  HeartPulse, MessageSquare, ShoppingCart,
  CircleAlert, Lightbulb, TrendingDown, ScanSearch, Filter,
  Bell, Send, PanelLeftClose, PanelLeft, Archive, Link as LinkIcon, ExternalLink,
  History, Heart, MessageCircle, Share2, Upload, MapPin,
  ThumbsUp, ThumbsDown, EyeOff, Eye, Phone, Mail
} from "lucide-react";
import * as S from './_shared';
export default function ActionPlanView({ ctx }) {
  const {
    ACOES_INIT,
    AcaoCard,
    AcaoDetalhe,
    AcaoModal,
    C,
    CES_COLS,
    CES_ETAPAS_NAMES,
    CES_TREND,
    CIDADES_COBERTURA,
    COOP_PLANOS_MOCK,
    CSAT_COLS,
    CSAT_ETAPAS_NAMES,
    CSAT_TREND,
    Card,
    DRIVERS_CANONICOS,
    DRIVER_TO_PILLAR,
    DistBar,
    ESCALA,
    ETAPA_DRIVER_AFFINITY,
    ETAPA_HIST,
    EtCard,
    EvaChat,
    EvaChatHistory,
    EvaInsights,
    F,
    HIST_ACOES_POR_ETAPA,
    JCFG,
    JICONS,
    LOGO,
    MESES_HIST,
    META_NPS,
    MUDANCAS_DESDE_ULTIMA_VISITA,
    MiniSparkline,
    NPSAnchor,
    PC,
    PDFExportModal,
    PER,
    PER_DEFAULT_LABELS,
    PER_OPTIONS,
    PILLAR_COLORS,
    PeriodPill,
    PeriodPillBig,
    SC,
    SHORT,
    SUCESSO_BADGES,
    SUCESSO_LEVELS,
    SYS_NPS,
    Section,
    TREND_BY_AGRUP,
    TT,
    Tag,
    ULTIMA_VISITA,
    UNIMED,
    VERBATINS_POR_ETAPA,
    Z_CX,
    Zonas,
    _META_CES_TR,
    _META_CSAT_TR,
    _META_NPS_TR,
    _SYS_CES_TR,
    _SYS_CSAT_TR,
    _SYS_NPS_TR,
    diasRest,
    etSt,
    exportPDF,
    fmtDt,
    getDriverInfo,
    getDriversForEtapa,
    getPilarOf,
    getSucessoStats,
    moe,
    pctChk,
    safeGanhoPp,
    tempoRelativo,
    todayStr
  } = S;
  const {
    DATA,
    SAUDACAO_EVA,
    acaoSel,
    acoes,
    adicionarComentario,
    agrupT,
    atualizarMensagensChatEva,
    bulkApplyEtapas,
    bulkApplyGerais,
    bulkOpen,
    bulkPct,
    busca,
    cidadesAtivas,
    compartilharPlano,
    concluirWizard,
    coopBusca,
    coopComentariosAbertos,
    coopCurtidas,
    coopDriverFilter,
    coopEtapaFilter,
    coopNovoComentario,
    coopPlanos,
    d,
    db,
    dd,
    de,
    delAcao,
    desocultarNotif,
    dj,
    driverSortMode,
    ds,
    editandoMeta,
    editandoMetaEt,
    etapaDriversFilter,
    etapaHistSel,
    etapaSel,
    evaChatAtivoId,
    evaChats,
    excluirChatEva,
    filtroCidadeAberto,
    filtroResp,
    filtroSt,
    gamificacaoOn,
    hiddenLines,
    historicoEvaVisivel,
    jorGraf,
    marcarComoLida,
    marcarTodasLidas,
    metas,
    metasCardOpen,
    metasEtapas,
    modal,
    mostrarOcultos,
    naoLidas,
    nenhumaCidade,
    notifModalFiltro,
    notifModalOpen,
    notifOpen,
    notifs,
    notifsOcultas,
    notifsVisiveis,
    novoChatEva,
    ocultarNotif,
    openPublishWizard,
    pB,
    pD,
    pE,
    pJ,
    pS,
    per,
    periodoCustom,
    periodoG,
    respDropOpen,
    segHistMode,
    segIndicador,
    selecionarChatEva,
    setAcaoSel,
    setAcoes,
    setAgrupT,
    setBulkApplyEtapas,
    setBulkApplyGerais,
    setBulkOpen,
    setBulkPct,
    setBusca,
    setCidadesAtivas,
    setConcluirWizard,
    setCoopBusca,
    setCoopComentariosAbertos,
    setCoopCurtidas,
    setCoopDriverFilter,
    setCoopEtapaFilter,
    setCoopNovoComentario,
    setCoopPlanos,
    setDriverSortMode,
    setEditandoMeta,
    setEditandoMetaEt,
    setEtapaDriversFilter,
    setEtapaHistSel,
    setEtapaSel,
    setEvaChatAtivoId,
    setEvaChats,
    setFiltroCidadeAberto,
    setFiltroResp,
    setFiltroSt,
    setGamificacaoOn,
    setHiddenLines,
    setHistoricoEvaVisivel,
    setMetaEtapa,
    setMetas,
    setMetasCardOpen,
    setMetasEtapas,
    setModal,
    setMostrarOcultos,
    setNotifFeedback,
    setNotifModalFiltro,
    setNotifModalOpen,
    setNotifOpen,
    setNotifs,
    setPB,
    setPD,
    setPE,
    setPJ,
    setPS,
    setPeriodoCustom,
    setPeriodoG,
    setPrefilledAcao,
    setRespDropOpen,
    setSegIndicador,
    setStDropOpen,
    setSucessoFiltroPeriodo,
    setSucessoModalOpen,
    setTab,
    setTipoBenefAberto,
    setTipoBeneficiario,
    setVerbatinsModal,
    stDropOpen,
    sucessoFiltroPeriodo,
    sucessoModalOpen,
    tab,
    tipoBenefAberto,
    tipoBeneficiario,
    todasCidades,
    toggleCidade,
    toggleComentarios,
    toggleCoopDriver,
    toggleCurtida,
    toggleLine,
    toggleSegHist
  } = ctx;
  return (()=>{
        const acoesFilt=acoes.filter(a=>{
          const stEmpty = filtroSt.size === 0;
          // Por padrão (sem filtro de status), arquivados ficam ocultos
          if(stEmpty && a.status==="arquivado") return false;
          // Se tem filtro de status, valida OR entre as opções marcadas
          if(!stEmpty) {
            let match = false;
            for (const s of filtroSt) {
              if (s === "concluido_sucesso") {
                if (a.status === "concluido" && a.sucesso) { match = true; break; }
              } else if (s === "concluido_geral") {
                if (a.status === "concluido") { match = true; break; }
              } else if (s === "atrasado") {
                // Atrasado = prazo no passado e ainda não concluído/arquivado
                const hojeStr = todayStr();
                if (a.prazo && a.prazo < hojeStr && a.status !== "concluido" && a.status !== "arquivado") { match = true; break; }
              } else if (a.status === s) {
                match = true; break;
              }
            }
            if (!match) return false;
          }
          // Filtro de responsável
          if (filtroResp.size > 0 && !filtroResp.has(a.resp)) return false;
          if(busca&&!a.titulo.toLowerCase().includes(busca.toLowerCase())) return false;
          return true;
        });
        // Lista única de responsáveis (pra popular o filtro)
        const respsUnicos = Array.from(new Set(acoes.map(a=>a.resp))).sort();
        const acaoSelecionada=acoes.find(a=>a.id===acaoSel);
        // Valores atuais (resultado real do período selecionado) — usado pra mostrar saldo vs metas
        const cesEtAtual  = d.etapas.filter(e=>(JCFG[e.e]&&JCFG[e.e].tipo)==="ces");
        const csatEtAtual = d.etapas.filter(e=>(JCFG[e.e]&&JCFG[e.e].tipo)==="csat");
        const valoresAtuais = {
          jcx:  d.etapas.length ? Math.round(d.etapas.reduce((s,e)=>s+e.v,0)/d.etapas.length) : 0,
          nps:  d.nps,
          csat: csatEtAtual.length ? Math.round(csatEtAtual.reduce((s,e)=>s+e.v,0)/csatEtAtual.length) : 0,
          ces:  cesEtAtual.length  ? Math.round(cesEtAtual.reduce((s,e)=>s+e.v,0)/cesEtAtual.length)   : 0,
        };
        const valorEtapaAtual = (nome) => {
          const et = d.etapas.find(e => e.e === nome);
          return et ? et.v : 0;
        };
        // Helper saldo: retorna texto formatado + cor baseada no delta atual - meta
        const calcSaldo = (atual, meta, isNps) => {
          const delta = atual - meta;
          const sign = delta > 0 ? "+" : delta < 0 ? "−" : "";
          const unit = isNps ? "pts" : "pp";
          const cor  = delta >= 0 ? C.green : (delta >= -10 ? C.orange : C.red);
          return { texto: `${sign}${Math.abs(delta)} ${unit}`, cor, delta };
        };
        // Helper bulk: aplica % de crescimento sobre o atual em todas as metas selecionadas
        const previewBulk = (() => {
          const pct = parseFloat(bulkPct);
          if (isNaN(pct)) return null;
          const fator = 1 + pct/100;
          const novasGerais = {
            jcx: Math.round(valoresAtuais.jcx * fator),
            nps: Math.round(valoresAtuais.nps * fator),
            csat: Math.round(valoresAtuais.csat * fator),
            ces: Math.round(valoresAtuais.ces * fator),
          };
          const novasEtapas = {};
          Object.keys(JCFG).forEach(nome => {
            novasEtapas[nome] = Math.round(valorEtapaAtual(nome) * fator);
          });
          const totalAfetadas = (bulkApplyGerais ? 4 : 0) + (bulkApplyEtapas ? 11 : 0);
          return { novasGerais, novasEtapas, totalAfetadas, fator };
        })();
        const aplicarBulkMetas = () => {
          if (!previewBulk) return;
          const pct = parseFloat(bulkPct);
          const msg = `Tem certeza que deseja sobrescrever ${previewBulk.totalAfetadas} metas com base no resultado atual + ${pct}%?\n\nEsta ação NÃO pode ser desfeita automaticamente.`;
          if (!confirm(msg)) return;
          if (bulkApplyGerais) {
            setMetas(previewBulk.novasGerais);
          }
          if (bulkApplyEtapas) {
            Object.keys(JCFG).forEach(nome => {
              setMetaEtapa(nome, previewBulk.novasEtapas[nome]);
            });
          }
          setBulkOpen(false);
          setBulkPct("");
        };
        return <div style={{display:"flex",flexDirection:"column",gap:14}}>
          {/* Metas do plano de ação (editáveis) */}
          <Card style={{padding:"14px 18px",background:`linear-gradient(135deg,${C.greenBg} 0%,${C.surface} 60%)`,border:`1px solid ${C.g300}`}}>
            <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:metasCardOpen?10:0,gap:12,flexWrap:"wrap"}}>
              <div style={{display:"flex",alignItems:"center",gap:8}}>
                <div style={{width:28,height:28,background:C.g700,borderRadius:8,display:"flex",alignItems:"center",justifyContent:"center"}}>
                  <Crosshair size={15} color="#FFFFFF"/>
                </div>
                <div>
                  <div style={{fontSize:13,fontWeight:700,color:C.text,letterSpacing:"-0.02em"}}>Metas do plano de ação</div>
                  {metasCardOpen && <div style={{fontSize:10,color:C.text4}}>Metas configuradas no plano de ação e usadas como referência em todo o dashboard. Clique no número para editar.</div>}
                  {!metasCardOpen && <div style={{fontSize:10,color:C.text4}}>Card minimizado — clique em ↓ para expandir</div>}
                </div>
              </div>
              <div style={{display:"flex",alignItems:"center",gap:8}}>
                {/* Botão Ajustar todas (bulk) — só aparece quando card está aberto */}
                {metasCardOpen && <button onClick={()=>setBulkOpen(o=>!o)}
                  style={{display:"flex",alignItems:"center",gap:6,
                    background:bulkOpen?C.g700:C.surface,
                    color:bulkOpen?"#FFFFFF":C.g700,
                    border:`1px solid ${C.g700}`,borderRadius:10,
                    padding:"7px 13px",fontSize:11,fontWeight:600,
                    cursor:"pointer",fontFamily:"inherit",transition:"all .15s",
                    boxShadow:bulkOpen?"0 2px 6px rgba(22,101,52,.2)":"none"}}>
                  <TrendingUp size={13}/> Ajustar todas as metas
                </button>}
                {/* Botão Minimizar/Expandir */}
                <button onClick={()=>setMetasCardOpen(o=>!o)}
                  title={metasCardOpen?"Minimizar":"Expandir"}
                  style={{display:"flex",alignItems:"center",justifyContent:"center",
                    background:C.surface,color:C.g700,
                    border:`1px solid ${C.border}`,borderRadius:10,
                    width:32,height:32,
                    cursor:"pointer",fontFamily:"inherit",transition:"all .15s"}}>
                  {metasCardOpen ? <ChevronUp size={15}/> : <ChevronDown size={15}/>}
                </button>
              </div>
            </div>

            {/* Corpo do card — tudo só aparece quando metasCardOpen=true */}
            {metasCardOpen && <>

            {/* Form expansivo de bulk adjust */}
            {bulkOpen && <div style={{
              background:C.surface,border:`1.5px solid ${C.g300}`,borderRadius:12,
              padding:"14px 16px",marginBottom:14,
              boxShadow:"inset 0 1px 3px rgba(0,0,0,.04)"
            }}>
              <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:10}}>
                <TrendingUp size={14} color={C.g700}/>
                <div style={{fontSize:11,fontWeight:700,color:C.g700,textTransform:"uppercase",letterSpacing:"0.05em"}}>
                  Aumentar todas as metas em % sobre o resultado atual
                </div>
              </div>
              <div style={{display:"flex",gap:14,alignItems:"flex-start",flexWrap:"wrap"}}>
                {/* Input do % */}
                <div style={{flex:"0 0 auto"}}>
                  <label style={{fontSize:9,color:C.text4,fontWeight:600,display:"block",marginBottom:3,textTransform:"uppercase",letterSpacing:"0.04em"}}>% de crescimento</label>
                  <div style={{display:"flex",alignItems:"baseline",gap:2,border:`1.5px solid ${C.g300}`,borderRadius:8,padding:"6px 10px",background:C.surface}}>
                    <span style={{fontSize:14,fontWeight:700,color:C.text3}}>+</span>
                    <input type="number" value={bulkPct} onChange={e=>setBulkPct(e.target.value)}
                      placeholder="10" min="0" step="1" autoFocus
                      style={{width:60,fontSize:24,fontWeight:700,color:C.g700,
                        border:"none",outline:"none",fontFamily:"inherit",background:"transparent",padding:0,letterSpacing:"-0.03em"}}/>
                    <span style={{fontSize:14,fontWeight:700,color:C.g700}}>%</span>
                  </div>
                  <div style={{fontSize:9,color:C.text4,marginTop:4,maxWidth:160,lineHeight:1.4}}>
                    Aplica sobre o valor <b>atual</b>, não sobre a meta antiga.
                  </div>
                </div>

                {/* Toggles de escopo */}
                <div style={{flex:"1 1 200px",display:"flex",flexDirection:"column",gap:6}}>
                  <label style={{fontSize:9,color:C.text4,fontWeight:600,display:"block",textTransform:"uppercase",letterSpacing:"0.04em"}}>Aplicar em</label>
                  <label style={{display:"flex",alignItems:"center",gap:8,cursor:"pointer",padding:"6px 10px",borderRadius:8,background:bulkApplyGerais?C.greenBg:C.surf3,border:`1px solid ${bulkApplyGerais?C.g300:C.border}`}}>
                    <input type="checkbox" checked={bulkApplyGerais} onChange={e=>setBulkApplyGerais(e.target.checked)} style={{accentColor:C.g700,cursor:"pointer"}}/>
                    <span style={{fontSize:11,color:C.text2,fontWeight:600}}>Indicadores gerais (4)</span>
                  </label>
                  <label style={{display:"flex",alignItems:"center",gap:8,cursor:"pointer",padding:"6px 10px",borderRadius:8,background:bulkApplyEtapas?C.greenBg:C.surf3,border:`1px solid ${bulkApplyEtapas?C.g300:C.border}`}}>
                    <input type="checkbox" checked={bulkApplyEtapas} onChange={e=>setBulkApplyEtapas(e.target.checked)} style={{accentColor:C.g700,cursor:"pointer"}}/>
                    <span style={{fontSize:11,color:C.text2,fontWeight:600}}>Etapas da jornada (11)</span>
                  </label>
                </div>

                {/* Preview */}
                {previewBulk && (bulkApplyGerais || bulkApplyEtapas) && <div style={{flex:"2 1 280px",background:C.surf3,borderRadius:10,padding:"10px 14px",border:`1px solid ${C.border}`}}>
                  <div style={{fontSize:9,color:C.text4,fontWeight:700,textTransform:"uppercase",letterSpacing:"0.04em",marginBottom:6}}>Pré-visualização das mudanças</div>
                  <div style={{display:"flex",flexDirection:"column",gap:3}}>
                    {bulkApplyGerais && [
                      {l:"NPS Geral",  k:"nps", suf:""},
                      {l:"Jornada CX", k:"jcx", suf:"%"},
                      {l:"CSAT Médio", k:"csat",suf:"%"},
                      {l:"CES Médio",  k:"ces", suf:"%"},
                    ].map(m=>(
                      <div key={m.k} style={{display:"flex",alignItems:"center",justifyContent:"space-between",fontSize:10,color:C.text2}}>
                        <span style={{color:C.text3}}>{m.l}</span>
                        <span style={{fontFamily:F.mono}}>
                          atual <b style={{color:C.text}}>{valoresAtuais[m.k]}{m.suf}</b>
                          <span style={{color:C.text4,margin:"0 4px"}}>→</span>
                          nova meta <b style={{color:C.g700}}>{previewBulk.novasGerais[m.k]}{m.suf}</b>
                        </span>
                      </div>
                    ))}
                    {bulkApplyEtapas && bulkApplyGerais && <div style={{height:1,background:C.border,margin:"4px 0"}}/>}
                    {bulkApplyEtapas && <div style={{fontSize:9,color:C.text4,fontStyle:"italic"}}>+ as 11 etapas serão ajustadas pela mesma fórmula</div>}
                  </div>
                </div>}
              </div>

              {/* Botões de ação */}
              <div style={{display:"flex",gap:8,justifyContent:"flex-end",marginTop:14,paddingTop:12,borderTop:`1px solid ${C.border}`}}>
                <button onClick={()=>{setBulkOpen(false);setBulkPct("");}}
                  style={{background:"transparent",border:`1px solid ${C.border}`,borderRadius:8,
                    padding:"8px 16px",fontSize:11,fontWeight:600,color:C.text3,cursor:"pointer",fontFamily:"inherit"}}>
                  Cancelar
                </button>
                <button onClick={aplicarBulkMetas}
                  disabled={!previewBulk||(!bulkApplyGerais&&!bulkApplyEtapas)}
                  style={{background:(!previewBulk||(!bulkApplyGerais&&!bulkApplyEtapas))?C.border:C.g700,
                    color:"#FFFFFF",border:"none",borderRadius:8,
                    padding:"8px 16px",fontSize:11,fontWeight:700,
                    cursor:(!previewBulk||(!bulkApplyGerais&&!bulkApplyEtapas))?"default":"pointer",
                    fontFamily:"inherit",display:"flex",alignItems:"center",gap:5}}>
                  <CheckCircle2 size={13}/> Confirmar e aplicar a {previewBulk?previewBulk.totalAfetadas:0} metas
                </button>
              </div>
            </div>}
            <div style={{fontSize:10,color:C.text3,fontWeight:700,textTransform:"uppercase",letterSpacing:"0.06em",marginBottom:6}}>Indicadores gerais</div>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr 1fr",gap:10}}>
              {[
                {k:"nps",  l:"NPS Geral",  suf:"",  color:C.g700,    desc:"Net Promoter Score"},
                {k:"jcx",  l:"Jornada CX", suf:"%", color:"#d97706", desc:"média de todos os indicadores"},
                {k:"csat", l:"CSAT Médio", suf:"%", color:C.g600,    desc:"satisfação consolidada"},
                {k:"ces",  l:"CES Médio",  suf:"%", color:C.blue,    desc:"esforço consolidado"},
              ].map(m=>{
                const editing = editandoMeta === m.k;
                const atual = valoresAtuais[m.k];
                const saldo = calcSaldo(atual, metas[m.k], m.k === "nps");
                return <div key={m.k} style={{background:C.surface,borderRadius:12,padding:"12px 14px",border:`1px solid ${editing?m.color:C.border}`,transition:"all .15s",boxShadow:editing?`0 0 0 3px ${m.color}20`:"none"}}>
                  <div style={{fontSize:12,color:C.text,fontWeight:700,letterSpacing:"-0.01em",marginBottom:8}}>{m.l}</div>
                  {/* META vs ATUAL — 2 colunas explícitas com divisória */}
                  <div style={{display:"flex",alignItems:"stretch",gap:0}}>
                    {/* Coluna META */}
                    <div style={{flex:1,paddingRight:12}}>
                      <div style={{fontSize:9,fontWeight:700,color:m.color,textTransform:"uppercase",letterSpacing:"0.06em",marginBottom:2,display:"flex",alignItems:"center",gap:4}}>
                        <Crosshair size={9} color={m.color}/> Meta
                      </div>
                      {editing
                        ? <div style={{display:"flex",alignItems:"baseline",gap:2}}>
                            <input type="number" autoFocus value={metas[m.k]}
                              onChange={e=>setMetas({...metas,[m.k]:Number(e.target.value)||0})}
                              onBlur={()=>setEditandoMeta(null)}
                              onKeyDown={e=>{if(e.key==="Enter"||e.key==="Escape")setEditandoMeta(null);}}
                              style={{width:60,fontSize:28,fontWeight:700,color:m.color,letterSpacing:"-0.04em",border:"none",outline:"none",fontFamily:"inherit",background:"transparent",padding:0}}/>
                            <span style={{fontSize:18,fontWeight:700,color:m.color}}>{m.suf}</span>
                          </div>
                        : <div onClick={()=>setEditandoMeta(m.k)} style={{display:"flex",alignItems:"baseline",gap:2,cursor:"pointer"}}>
                            <span style={{fontSize:28,fontWeight:700,color:m.color,letterSpacing:"-0.04em"}}>{metas[m.k]}</span>
                            <span style={{fontSize:18,fontWeight:700,color:m.color}}>{m.suf}</span>
                            <Pencil size={10} color={C.text4} style={{marginLeft:4,opacity:.5}}/>
                          </div>
                      }
                    </div>
                    {/* Divisória vertical */}
                    <div style={{width:1,background:C.border,marginRight:12}}/>
                    {/* Coluna ATUAL */}
                    <div style={{flex:1}}>
                      <div style={{fontSize:9,fontWeight:700,color:C.text3,textTransform:"uppercase",letterSpacing:"0.06em",marginBottom:2,display:"flex",alignItems:"center",gap:4}}>
                        <Activity size={9} color={C.text3}/> {per.short}
                      </div>
                      <div style={{display:"flex",alignItems:"baseline",gap:2}}>
                        <span style={{fontSize:22,fontWeight:700,color:C.text2,letterSpacing:"-0.03em"}}>{atual}</span>
                        <span style={{fontSize:14,fontWeight:700,color:C.text2}}>{m.suf}</span>
                      </div>
                      <div style={{fontSize:10,fontWeight:700,color:saldo.cor,marginTop:1,display:"flex",alignItems:"center",gap:3}}>
                        {saldo.delta >= 0 ? <ArrowUpRight size={10}/> : <ArrowDownRight size={10}/>}
                        {saldo.texto}
                      </div>
                    </div>
                  </div>
                  <div style={{fontSize:9,color:C.text4,marginTop:8,paddingTop:6,borderTop:`1px solid ${C.border}`}}>{m.desc}</div>
                </div>;
              })}
            </div>

            {/* Metas das 11 etapas da jornada */}
            <div style={{marginTop:18,paddingTop:14,borderTop:`1px dashed ${C.border}`}}>
              <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:10}}>
                <div>
                  <div style={{fontSize:10,color:C.text3,fontWeight:700,textTransform:"uppercase",letterSpacing:"0.06em",marginBottom:2}}>Por etapa da jornada</div>
                  <div style={{fontSize:10,color:C.text4}}>11 etapas individuais — cada uma com sua meta CSAT ou CES. Clique no número para editar.</div>
                </div>
                <div style={{display:"flex",gap:8}}>
                  <div style={{display:"flex",alignItems:"center",gap:4,fontSize:10,color:C.text4}}>
                    <div style={{width:8,height:8,borderRadius:2,background:C.g600}}/>CSAT
                  </div>
                  <div style={{display:"flex",alignItems:"center",gap:4,fontSize:10,color:C.text4}}>
                    <div style={{width:8,height:8,borderRadius:2,background:C.blue}}/>CES
                  </div>
                </div>
              </div>
              <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill, minmax(210px, 1fr))",gap:8}}>
                {Object.keys(JCFG).map(nome=>{
                  const cfg=JCFG[nome];
                  const isCes=cfg.tipo==="ces";
                  const color=isCes?C.blue:C.g600;
                  const editing=editandoMetaEt===nome;
                  const IconComp=JICONS[nome];
                  const atualEt = valorEtapaAtual(nome);
                  const saldoEt = calcSaldo(atualEt, metasEtapas[nome], false);
                  return <div key={nome} style={{background:C.surface,borderRadius:10,padding:"10px 12px",border:`1px solid ${editing?color:C.border}`,transition:"all .15s",boxShadow:editing?`0 0 0 3px ${color}20`:"none",minWidth:0}}>
                    {/* Header com ícone e nome */}
                    <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:6}}>
                      <div style={{width:24,height:24,borderRadius:7,background:isCes?C.blueBg:C.greenBg,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
                        {IconComp&&<IconComp size={12} color={color} strokeWidth={1.8}/>}
                      </div>
                      <div style={{fontSize:11,color:C.text2,fontWeight:600,whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis",flex:1,minWidth:0}}>{nome}</div>
                    </div>
                    {/* META | ATUAL com divisória */}
                    <div style={{display:"flex",alignItems:"stretch",gap:0}}>
                      {/* Coluna META */}
                      <div style={{flex:1,paddingRight:8}}>
                        <div style={{fontSize:8,fontWeight:700,color,textTransform:"uppercase",letterSpacing:"0.06em",marginBottom:1}}>Meta</div>
                        {editing
                          ? <div style={{display:"flex",alignItems:"baseline",gap:1}}>
                              <input type="number" autoFocus value={metasEtapas[nome]}
                                onChange={e=>setMetaEtapa(nome,Number(e.target.value)||0)}
                                onBlur={()=>setEditandoMetaEt(null)}
                                onKeyDown={e=>{if(e.key==="Enter"||e.key==="Escape")setEditandoMetaEt(null);}}
                                style={{width:38,fontSize:18,fontWeight:700,color,letterSpacing:"-0.03em",border:"none",outline:"none",fontFamily:"inherit",background:"transparent",padding:0}}/>
                              <span style={{fontSize:11,fontWeight:700,color}}>%</span>
                            </div>
                          : <div onClick={()=>setEditandoMetaEt(nome)} style={{display:"flex",alignItems:"baseline",gap:1,cursor:"pointer"}}>
                              <span style={{fontSize:18,fontWeight:700,color,letterSpacing:"-0.03em"}}>{metasEtapas[nome]}</span>
                              <span style={{fontSize:11,fontWeight:700,color}}>%</span>
                              <Pencil size={8} color={C.text4} style={{marginLeft:3,opacity:.5}}/>
                            </div>
                        }
                      </div>
                      {/* Divisória vertical */}
                      <div style={{width:1,background:C.border,marginRight:8}}/>
                      {/* Coluna ATUAL */}
                      <div style={{flex:1}}>
                        <div style={{fontSize:8,fontWeight:700,color:C.text3,textTransform:"uppercase",letterSpacing:"0.06em",marginBottom:1}}>{per.short}</div>
                        <div style={{display:"flex",alignItems:"baseline",gap:1}}>
                          <span style={{fontSize:16,fontWeight:700,color:C.text2,letterSpacing:"-0.03em"}}>{atualEt}</span>
                          <span style={{fontSize:11,fontWeight:700,color:C.text2}}>%</span>
                        </div>
                        <div style={{fontSize:9,fontWeight:700,color:saldoEt.cor,marginTop:1,display:"flex",alignItems:"center",gap:2}}>
                          {saldoEt.delta >= 0 ? <ArrowUpRight size={9}/> : <ArrowDownRight size={9}/>}
                          {saldoEt.texto}
                        </div>
                      </div>
                    </div>
                  </div>;
                })}
              </div>
            </div>
            </>}
          </Card>

          {/* Card de Sucessos — modo gamificado ou modo simples (corporativo) */}
          {(() => {
            const sg = getSucessoStats(acoes);
            // Styling muda conforme o modo
            const cardBg = gamificacaoOn
              ? `linear-gradient(135deg,${sg.level.bg} 0%,${C.surface} 55%,${C.greenBg} 100%)`
              : `linear-gradient(135deg,${C.greenBg} 0%,${C.surface} 70%)`;
            const cardBorder = gamificacaoOn ? sg.level.color : C.g300;
            const cardShadow = gamificacaoOn ? `0 4px 16px ${sg.level.color}15` : "none";

            // Toggle button — sempre visível, em ambos os modos
            const toggleBtn = <button onClick={()=>setGamificacaoOn(o=>!o)}
              title={gamificacaoOn?"Mudar para modo simples (sem níveis e conquistas)":"Mudar para modo gamificado (com níveis e conquistas)"}
              style={{
                display:"flex",alignItems:"center",gap:5,
                background:gamificacaoOn?C.surface:"rgba(255,255,255,.7)",
                color:gamificacaoOn?C.g700:C.text3,
                border:`1px solid ${gamificacaoOn?sg.level.color+"60":C.border}`,
                borderRadius:20,
                padding:"4px 10px",fontSize:10,fontWeight:600,
                cursor:"pointer",fontFamily:"inherit",transition:"all .15s",
                flexShrink:0
              }}>
              {gamificacaoOn
                ? <><Sparkles size={10}/> Gamificação ativa</>
                : <><BarChart3 size={10}/> Modo simples</>}
            </button>;

            // Botão "Ver detalhes" — abre modal com filtros de período + gráfico de evolução + breakdown por etapa
            const verDetalhesBtn = <button onClick={()=>setSucessoModalOpen(true)}
              title="Ver evolução temporal, filtros de período e breakdown por etapa"
              style={{
                display:"flex",alignItems:"center",gap:5,
                background:C.greenBg,
                color:C.green,
                border:`1px solid ${C.green}50`,
                borderRadius:20,
                padding:"4px 10px",fontSize:10,fontWeight:700,
                cursor:"pointer",fontFamily:"inherit",transition:"all .15s",
                flexShrink:0
              }}>
              <TrendingUp size={10}/> Ver detalhes
            </button>;

            const actionBtns = <div style={{display:"flex",gap:6,flexShrink:0}}>{verDetalhesBtn}{toggleBtn}</div>;

            return <Card style={{
              padding:"16px 20px",
              background:cardBg,
              border:`1.5px solid ${cardBorder}`,
              boxShadow:cardShadow,
              position:"relative",overflow:"hidden"
            }}>
              {/* Efeito decorativo de fundo (só no modo gamificado) */}
              {gamificacaoOn && <div style={{position:"absolute",top:-20,right:-10,fontSize:120,opacity:.07,lineHeight:1,userSelect:"none",pointerEvents:"none"}}>{sg.level.icon}</div>}

              {gamificacaoOn ? (
                /* ───── MODO GAMIFICADO ───── */
                <>
                  <div style={{display:"flex",alignItems:"flex-start",gap:14,marginBottom:12,position:"relative"}}>
                    {/* Emoji do nível */}
                    <div style={{
                      width:58,height:58,borderRadius:16,
                      background:`linear-gradient(135deg,${sg.level.bg},#FFFFFF)`,
                      border:`2px solid ${sg.level.color}`,
                      display:"flex",alignItems:"center",justifyContent:"center",
                      fontSize:32,flexShrink:0,
                      boxShadow:`0 4px 12px ${sg.level.color}25`
                    }}>{sg.level.icon}</div>
                    {/* Nível e total */}
                    <div style={{flex:1,minWidth:0}}>
                      <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:2,flexWrap:"wrap"}}>
                        <div style={{fontSize:10,fontWeight:700,color:C.g700,textTransform:"uppercase",letterSpacing:"0.08em",display:"flex",alignItems:"center",gap:4}}>
                          <Trophy size={11} color={C.green}/> Sucessos do plano de ação
                        </div>
                        <div style={{padding:"2px 8px",borderRadius:20,background:sg.level.color,color:"#FFFFFF",fontSize:9,fontWeight:700,textTransform:"uppercase",letterSpacing:"0.05em"}}>Nível {sg.level.id}</div>
                      </div>
                      <div style={{display:"flex",alignItems:"baseline",gap:10,flexWrap:"wrap"}}>
                        <div style={{fontSize:22,fontWeight:700,color:sg.level.color,letterSpacing:"-0.03em",lineHeight:1}}>{sg.level.name}</div>
                        <div style={{fontSize:26,fontWeight:700,color:C.green,letterSpacing:"-0.04em",lineHeight:1}}>+{sg.totalPp}pp</div>
                        <div style={{fontSize:11,color:C.text3,fontWeight:500}}>{sg.numSucessos} {sg.numSucessos===1?"ação com sucesso":"ações com sucesso"}</div>
                      </div>
                    </div>
                    {/* Botões de ação */}
                    {actionBtns}
                  </div>

                  {/* Progress bar pro próximo nível */}
                  {sg.nextLevel ? <div style={{marginBottom:12,position:"relative"}}>
                    <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",fontSize:10,color:C.text3,marginBottom:4,fontWeight:500}}>
                      <span>Progresso para <b style={{color:sg.nextLevel.color}}>{sg.nextLevel.icon} {sg.nextLevel.name}</b></span>
                      <span>faltam <b style={{color:C.text}}>+{sg.nextLevel.min - sg.totalPp}pp</b></span>
                    </div>
                    <div style={{height:8,background:C.surf3,borderRadius:20,overflow:"hidden",border:`1px solid ${C.border}`}}>
                      <div style={{
                        height:"100%",
                        width:`${sg.progressPct}%`,
                        background:`linear-gradient(90deg,${sg.level.color},${sg.nextLevel.color})`,
                        borderRadius:20,
                        transition:"width .5s ease",
                        boxShadow:`0 0 8px ${sg.level.color}60`
                      }}/>
                    </div>
                  </div> : <div style={{marginBottom:12,padding:"8px 12px",background:sg.level.bg,borderRadius:8,border:`1px solid ${sg.level.color}40`,textAlign:"center",fontSize:11,color:sg.level.color,fontWeight:700}}>
                    👑 Nível máximo atingido — você é uma lenda do CX!
                  </div>}

                  {/* Badges (conquistas) */}
                  <div>
                    <div style={{fontSize:9,fontWeight:700,color:C.text3,textTransform:"uppercase",letterSpacing:"0.06em",marginBottom:6,display:"flex",alignItems:"center",gap:6}}>
                      <Sparkles size={10} color={C.g700}/> Conquistas
                      <span style={{color:C.text4,fontWeight:500,textTransform:"none",letterSpacing:"normal"}}>· {sg.unlockedBadges.length}/{SUCESSO_BADGES.length} desbloqueadas</span>
                    </div>
                    <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
                      {SUCESSO_BADGES.map(b => {
                        const unlocked = sg.unlockedBadges.some(ub => ub.id === b.id);
                        return <div key={b.id} title={`${b.name} — ${b.desc}${unlocked?"":" (bloqueada)"}`} style={{
                          display:"flex",alignItems:"center",gap:5,
                          padding:"5px 10px",borderRadius:20,
                          background:unlocked?C.greenBg:"#F9FAFB",
                          border:`1px solid ${unlocked?C.green+"60":"#E5E7EB"}`,
                          cursor:"default",
                          opacity:unlocked?1:.55,
                          transition:"all .15s"
                        }}>
                          <span style={{fontSize:13,filter:unlocked?"none":"grayscale(100%)"}}>{b.icon}</span>
                          <span style={{fontSize:10,fontWeight:600,color:unlocked?C.text2:C.text4,whiteSpace:"nowrap"}}>{b.name}</span>
                        </div>;
                      })}
                    </div>
                  </div>
                </>
              ) : (
                /* ───── MODO SIMPLES (corporativo) ───── */
                <div style={{display:"flex",alignItems:"center",gap:14}}>
                  {/* Ícone neutro */}
                  <div style={{
                    width:48,height:48,borderRadius:12,
                    background:C.g700,
                    display:"flex",alignItems:"center",justifyContent:"center",
                    flexShrink:0
                  }}>
                    <Trophy size={22} color="#FFFFFF"/>
                  </div>
                  {/* Stats */}
                  <div style={{flex:1,minWidth:0}}>
                    <div style={{fontSize:10,fontWeight:700,color:C.g700,textTransform:"uppercase",letterSpacing:"0.08em",marginBottom:4}}>
                      Sucessos do plano de ação
                    </div>
                    <div style={{display:"flex",alignItems:"baseline",gap:12,flexWrap:"wrap",marginBottom:2}}>
                      <div style={{fontSize:28,fontWeight:700,color:C.green,letterSpacing:"-0.04em",lineHeight:1}}>+{sg.totalPp}pp</div>
                      <div style={{fontSize:11,color:C.text3,fontWeight:500}}>de impacto cumulado</div>
                    </div>
                    <div style={{fontSize:11,color:C.text3}}>
                      <b style={{color:C.text2}}>{sg.numSucessos}</b> {sg.numSucessos===1?"ação concluída com sucesso registrado":"ações concluídas com sucesso registrado"}
                      {sg.maxSingle > 0 && <> · maior ganho individual: <b style={{color:C.text2}}>+{sg.maxSingle}pp</b></>}
                    </div>
                  </div>
                  {/* Botões de ação */}
                  {actionBtns}
                </div>
              )}
            </Card>;
          })()}

          {/* Summary */}
          <div style={{display:"flex",gap:12,flexWrap:"wrap"}}>
            <button onClick={()=>setModal("new")} style={{display:"flex",alignItems:"center",gap:10,background:C.g700,color:"#FFFFFF",border:"none",borderRadius:14,padding:"12px 20px 12px 14px",cursor:"pointer",fontSize:13,fontWeight:600,flexShrink:0,boxShadow:"0 2px 8px rgba(22,101,52,.25)",transition:"all .15s"}}>
              <div style={{width:28,height:28,borderRadius:10,background:"rgba(255,255,255,.18)",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
                <ClipboardList size={16} color="#FFFFFF" strokeWidth={2.2}/>
              </div>
              Nova ação
              <Plus size={14} strokeWidth={2.8}/>
            </button>
            {[
              {l:"Total", v:acoes.length, c:C.text},
              {l:"Concluídas", v:acoes.filter(a=>a.status==="concluido").length, c:C.green},
              {l:"Em andamento", v:acoes.filter(a=>a.status==="em_andamento").length, c:C.blue},
              {l:"Atrasadas", v:acoes.filter(a=>diasRest(a.prazo)<0&&a.status!=="concluido").length, c:C.red},
            ].map((k,i)=>(
              <Card key={i} style={{flex:1,minWidth:110,padding:"14px 16px"}}>
                <div style={{fontSize:10,color:C.text4,fontWeight:600,textTransform:"uppercase",marginBottom:4}}>{k.l}</div>
                <div style={{fontSize:28,fontWeight:700,color:k.c,letterSpacing:"-0.04em"}}>{k.v}</div>
              </Card>
            ))}
          </div>
          {/* Filters */}
          <div style={{display:"flex",gap:8,alignItems:"center",flexWrap:"wrap"}}>
            <div style={{display:"flex",alignItems:"center",gap:6,border:`1px solid ${C.border}`,borderRadius:10,padding:"7px 12px",background:C.surface}}>
              <Search size={13} color={C.text4}/><input value={busca} onChange={e=>setBusca(e.target.value)} placeholder="Buscar..." style={{border:"none",outline:"none",fontSize:12,background:"transparent",color:C.text,fontFamily:"inherit",minWidth:120}}/>
            </div>

            {/* Filtro de Status (multi-select) */}
            <div style={{position:"relative"}}>
              <button onClick={()=>{setStDropOpen(o=>!o); setRespDropOpen(false);}}
                style={{display:"flex",alignItems:"center",gap:6,border:`1px solid ${stDropOpen||filtroSt.size>0?C.g700:C.border}`,borderRadius:10,padding:"7px 12px",fontSize:12,background:C.surface,fontFamily:"inherit",color:C.text,cursor:"pointer",fontWeight:filtroSt.size>0?600:400}}>
                <Filter size={12} color={filtroSt.size>0?C.g700:C.text3}/>
                Status
                {filtroSt.size>0 && <span style={{background:C.g700,color:"#FFFFFF",borderRadius:20,padding:"1px 7px",fontSize:10,fontWeight:700}}>{filtroSt.size}</span>}
                <ChevronDown size={12} color={C.text3} style={{transform:stDropOpen?"rotate(180deg)":"none",transition:"transform .15s"}}/>
              </button>
              {stDropOpen && <>
                <div onClick={()=>setStDropOpen(false)} style={{position:"fixed",inset:0,zIndex:90}}/>
                <div style={{position:"absolute",top:"calc(100% + 6px)",left:0,background:C.surface,border:`1px solid ${C.border}`,borderRadius:12,boxShadow:"0 12px 32px rgba(0,0,0,.12)",padding:"8px 0",minWidth:240,zIndex:91}}>
                  <div style={{padding:"4px 14px 8px",display:"flex",alignItems:"center",justifyContent:"space-between",borderBottom:`1px solid ${C.border}`,marginBottom:4}}>
                    <div style={{fontSize:10,fontWeight:700,color:C.text3,textTransform:"uppercase",letterSpacing:"0.05em"}}>Filtrar por status</div>
                    {filtroSt.size>0 && <button onClick={()=>setFiltroSt(new Set())} style={{background:"none",border:"none",cursor:"pointer",fontSize:10,color:C.g700,fontWeight:600,fontFamily:"inherit"}}>Limpar</button>}
                  </div>
                  {[
                    {k:"pendente",    lbl:"Pendente",                dot:SC.pendente.color},
                    {k:"em_andamento",lbl:"Em andamento",            dot:SC.em_andamento.color},
                    {k:"atrasado",    lbl:"⚠️ Atrasados",              dot:C.red},
                    {k:"concluido_geral",   lbl:"Concluídos (Geral)",      dot:SC.concluido.color},
                    {k:"concluido_sucesso", lbl:"🏆 Concluídos com Sucesso", dot:C.green},
                    {k:"pausado",     lbl:"Pausado",                 dot:SC.pausado.color},
                    {k:"arquivado",   lbl:"Arquivado",               dot:SC.arquivado.color},
                  ].map(opt=>{
                    const checked = filtroSt.has(opt.k);
                    return <label key={opt.k} style={{display:"flex",alignItems:"center",gap:10,padding:"8px 14px",cursor:"pointer",fontSize:12,color:C.text,background:checked?C.greenBg:"transparent"}}
                      onClick={()=>{
                        const next = new Set(filtroSt);
                        if (next.has(opt.k)) next.delete(opt.k); else next.add(opt.k);
                        setFiltroSt(next);
                      }}>
                      <div style={{width:16,height:16,borderRadius:4,border:`1.5px solid ${checked?C.g700:C.border2}`,background:checked?C.g700:C.surface,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
                        {checked && <svg width="10" height="8" viewBox="0 0 10 8" fill="none"><path d="M1 4L3.5 6.5L9 1" stroke="white" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/></svg>}
                      </div>
                      <div style={{width:8,height:8,borderRadius:"50%",background:opt.dot,flexShrink:0}}/>
                      <span>{opt.lbl}</span>
                    </label>;
                  })}
                </div>
              </>}
            </div>

            {/* Filtro de Responsável (multi-select) */}
            <div style={{position:"relative"}}>
              <button onClick={()=>{setRespDropOpen(o=>!o); setStDropOpen(false);}}
                style={{display:"flex",alignItems:"center",gap:6,border:`1px solid ${respDropOpen||filtroResp.size>0?C.purple:C.border}`,borderRadius:10,padding:"7px 12px",fontSize:12,background:C.surface,fontFamily:"inherit",color:C.text,cursor:"pointer",fontWeight:filtroResp.size>0?600:400}}>
                <Users size={12} color={filtroResp.size>0?C.purple:C.text3}/>
                Responsável
                {filtroResp.size>0 && <span style={{background:C.purple,color:"#FFFFFF",borderRadius:20,padding:"1px 7px",fontSize:10,fontWeight:700}}>{filtroResp.size}</span>}
                <ChevronDown size={12} color={C.text3} style={{transform:respDropOpen?"rotate(180deg)":"none",transition:"transform .15s"}}/>
              </button>
              {respDropOpen && <>
                <div onClick={()=>setRespDropOpen(false)} style={{position:"fixed",inset:0,zIndex:90}}/>
                <div style={{position:"absolute",top:"calc(100% + 6px)",left:0,background:C.surface,border:`1px solid ${C.border}`,borderRadius:12,boxShadow:"0 12px 32px rgba(0,0,0,.12)",padding:"8px 0",minWidth:260,maxHeight:340,overflowY:"auto",zIndex:91}}>
                  <div style={{padding:"4px 14px 8px",display:"flex",alignItems:"center",justifyContent:"space-between",borderBottom:`1px solid ${C.border}`,marginBottom:4,position:"sticky",top:0,background:C.surface}}>
                    <div style={{fontSize:10,fontWeight:700,color:C.text3,textTransform:"uppercase",letterSpacing:"0.05em"}}>Filtrar por responsável</div>
                    {filtroResp.size>0 && <button onClick={()=>setFiltroResp(new Set())} style={{background:"none",border:"none",cursor:"pointer",fontSize:10,color:C.purple,fontWeight:600,fontFamily:"inherit"}}>Limpar</button>}
                  </div>
                  {respsUnicos.length === 0 && <div style={{padding:"12px 14px",fontSize:11,color:C.text4,fontStyle:"italic"}}>Nenhum responsável cadastrado</div>}
                  {respsUnicos.map(r=>{
                    const checked = filtroResp.has(r);
                    const countResp = acoes.filter(a=>a.resp===r).length;
                    return <label key={r} style={{display:"flex",alignItems:"center",gap:10,padding:"8px 14px",cursor:"pointer",fontSize:12,color:C.text,background:checked?"#F8F0FF":"transparent"}}
                      onClick={()=>{
                        const next = new Set(filtroResp);
                        if (next.has(r)) next.delete(r); else next.add(r);
                        setFiltroResp(next);
                      }}>
                      <div style={{width:16,height:16,borderRadius:4,border:`1.5px solid ${checked?C.purple:C.border2}`,background:checked?C.purple:C.surface,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
                        {checked && <svg width="10" height="8" viewBox="0 0 10 8" fill="none"><path d="M1 4L3.5 6.5L9 1" stroke="white" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/></svg>}
                      </div>
                      <span style={{flex:1,whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis"}}>{r}</span>
                      <span style={{fontSize:10,color:C.text4,fontWeight:500}}>{countResp}</span>
                    </label>;
                  })}
                </div>
              </>}
            </div>

            <span style={{fontSize:11,color:C.text4,marginLeft:"auto"}}>{acoesFilt.length} de {acoes.length} ações</span>
          </div>
          {/* Cards + detalhe */}
          <div style={{display:"grid",gridTemplateColumns:acaoSelecionada?"320px 1fr":"repeat(2,1fr)",gap:14}}>
            <div style={{display:"flex",flexDirection:"column",gap:10}}>
              {acoesFilt.map(a=><AcaoCard key={a.id} a={a} sel={acaoSel===a.id}
                onSel={id=>setAcaoSel(id)} onEdit={a=>setModal(a)} onDel={delAcao}/>)}
              {acoesFilt.length===0&&<Card style={{padding:"32px",textAlign:"center"}}><div style={{color:C.text4,fontSize:13}}>Nenhuma ação encontrada</div></Card>}
            </div>
            {acaoSelecionada&&<AcaoDetalhe a={acaoSelecionada} onClose={()=>setAcaoSel(null)}
              onUpdate={u=>setAcoes(prev=>prev.map(a=>a.id===u.id?u:a))}
              onShare={compartilharPlano}
              onPublishWizard={openPublishWizard}/>}
          </div>
        </div>;
      })();
}
